<template>
  <div class="mine-content">
    <div class="m-content">
      <RateScale v-for = "(pep,index) in testPassages" :content="pep" :key="index" v-on:listenToChildEvent="showMsg"></RateScale>
      <div class="btn-group">
           <button class="default-btn large-btn submit-btn" @click="submitDta" v-preventReClick>提交</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import RateScale from '@/components/RateScale.vue'
import axios from 'axios'
import qs from 'qs'
import setWechatTitle from '@/utils/setWechatTitle.js'
export default {
  props: {
    id: Number
  },
  name: 'DecisionStyle',
  components:{
    'RateScale':RateScale
  },
  data(){
    return {
      testPassages:[
        {'num':1,'order':'1.','title':'在选修课程时，我倾向于依赖我的直觉。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':2,'order':'2.','title':'关于毕业后何去何从这个问题，如果没有跟他人共同商议的话，我很难做出决定。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':3,'order':'3.','title':'当自己需要做出决定时，对我来说，感觉做出一个让自己满意的决策比做出一个合理的决策更加重要。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':4,'order':'4.','title':'在考研还是就业这个问题上，我会将搜集到的信息加以比较和分析，以保证在决策前了解正确的事实。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':5,'order':'5.','title':'我需要利用他人的建议来帮助我做出毕业后是工作还是考研这个决定。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':6,'order':'6.','title':'我之所以推迟做出毕业去哪这个决定，是因为考虑这个事情会让我心神不定。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':7,'order':'7.','title':'我会系统的搜集各种信息，并且仔细分析各种可能性，来决定我毕业后的道路选择。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':8,'order':'8.','title':'当我需要做出毕业后该何去何从这个决策时，我会快速的做出一个决策，因为拖延时间越久我会越焦虑。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':9,'order':'9.','title':'在填报专业时，我没有过多的去了解这个专业，而是基于冲动就做出了决定。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':10,'order':'10.','title':'当我在面临决策困难时，我希望有人能给我指出正确的方向。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':11,'order':'11.','title':'当决定要找工作时，我需要深思熟虑才能确定一个目标职位。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':12,'order':'12.','title':'当初在选择专业时，我信任自己内部的感觉和反应。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':13,'order':'13.','title':'做决定的时候，我会认真权衡各项可选择方案的利弊得失，从中选择一种最优的方案。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':14,'order':'13.','title':'我暂时还不想做出毕业去向这个决定，直到压力迫使。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':15,'order':'15.','title':'每当需要做决定时，我常常做出冲动的决定。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':16,'order':'16.','title':'我依赖本能做出我的职业决策。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':17,'order':'17.','title':'关于毕业后何去何从这个问题，我觉得没有必要去分析每一种去向选择，跟着自己的感觉走就行。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':18,'order':'18.','title':'当需要做出职业决策时，我常常需要他人的协助。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':19,'order':'19.','title':'只要有可能，我会推迟做出毕业后的职业决策。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':20,'order':'20.','title':'我经常在受到某一时刻的刺激下，马上就做出了决定。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':21,'order':'21.','title':'即使马上就要面临求职的问题，我也不会现在就做出决定，而是一直往后推迟。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':22,'order':'22.','title':'如果得到他人的支持，我会更容易确定毕业后的求职目标。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':23,'order':'23.','title':'如果毕业后找工作，我会到最后一刻才决定我要找一份什么样的工作。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':24,'order':'24.','title':'我会很快的确定自己的职业目标。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':25,'order':'25.','title':'我在做职业决策时，通常会在理性的分析基础上再做出决定。','show':true,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''}
        ],
      answers:[],
      result:'',
      submitNum:0
    }
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created(){
    setWechatTitle('生涯驿站-决策风格测评');
  },
  methods:{
    showMsg(answer,num){
      let chooseData = {id:num,answer:answer}
      this.answers.map((item,index)=>{
        if(item.id==num){
           this.answers.splice(index,1)
        }
      })
      this.answers.push(chooseData)
      this.testPassages[num-1].errorMessage=''
    },
    addAnswerToResult(){
      this.result=''
      this.answers.map((item,index)=>{
        this.result+=item.id+"$"+item.answer;
        if(item.id<25){
          this.result+="}";
        }
      })
    },
    saveData(result){
      if(this.submitNum==0){
        this.submitNum=1
        const options = {
          method: 'POST',
          headers: {
            'content-type': 'application/x-www-form-urlencoded'
          },
          data: qs.stringify({
            submitdata: result,
            openId: this.shengyaUser.openid
          }),
          url: '/cob/saveCosDecisionAnswer.do'
        };
        axios(options)
          .then((response)=>{
            if(response.data.result.success){
              let cddqAnswer = response.data
              let shengyaUser = cddqAnswer.data.user
              this.$bus.$emit('play-finish', shengyaUser)
            }
          })
          .catch((error)=>{
            console.log(error);
          });
      }
    },
    submitDta(){
      this.answers.sort((a,b)=>{return a.id-b.id})
      let allData=false
      if(this.answers.length==this.testPassages.length){
        allData=true
      }
      if(!allData){
        this.testPassages.map((item,index)=>{
          if(item.show){
            item.errorMessage='请回答此题'
          }
          this.answers.map((answer,n)=>{
            if(item.num==answer.id){
              item.errorMessage=''
            }
          })
        })
        return false
      }
      this.addAnswerToResult()
      if(this.result){
        this.saveData(this.result)
      }
    }
  }
}
</script>
